import styled from "styled-components";

export const AboutTabWrapper = styled.div`
  display: flex;
  justify-content: space-around;
  width: 100%;
  height: 348px;
`;

export const AboutTabImageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 141px;
  width: 35%;
  background-color: #222020;
`;

export const AboutImageLogo = styled.img`
  width: 50px;
  height: 50px;
`;

export const AboutTabTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 58px;
  padding-left: 10px;
`;

export const AboutTabExternalLink = styled.a`
  color: lightblue;
`;

export const AboutTabCopyRightWrapper = styled.div`
  margin-bottom: 0;
`;

export const AboutBuildVersionWrapper = styled.div`
  margin-top: 0;
`;

export const AboutVersionWrapper = styled.div`
  margin-bottom: 0;
  margin-top: 0;
`;

export const AboutTabHeadingWrapper = styled.h4`
  margin-bottom: 0;
`;

export const AboutTabTrademarkWrapper = AboutBuildVersionWrapper;
